<div
  *ngIf="loading"
  class="spinner"
  style="
    background-color: #fffbff;
    width: 100%;
    height: calc(100vh - 70px);
    display: flex;
    justify-content: center;
    align-items: center;
  "
>
  <mat-spinner></mat-spinner>
</div>

<div class="modal" (click)="closeModal($event)" *ngIf="showFilters">
  <div class="modal-content">
    <strong>FILTROS</strong>

    <div
      class="d-flex flex-column align-items-center justify-content-center mt-3"
      style="width: fit-content"
    >
      <form [formGroup]="searchFilter" class="container-form-search">
        <div class="container-input-search">
          <div class="filters-input">
            <label class="label-input-search">Bairro</label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="sublocalityComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">Todos</mat-option>
                <mat-option
                  *ngFor="let sublocality of sublocalities"
                  [value]="sublocality"
                >
                  {{ sublocality }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="filters-input">
            <label class="label-input-search">Local das ocorrências</label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="placeComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">Todos</mat-option>
                <mat-option
                  *ngFor="let place of placeComplaint"
                  [value]="place"
                >
                  {{ place }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div
            class="filters-input"
            *ngIf="searchFilter.controls['placeComplaint'].value == 'Ônibus'"
          >
            <label class="label-input-search">Linha de ônibus</label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select formControlName="busLine" class="mat-select-search">
                <mat-option [value]="'Todos'">Todos</mat-option>
                <mat-option *ngFor="let line of linesName" [value]="line">
                  {{ line }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="filters-input">
            <label class="label-input-search">Tipo de importunação</label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="typeComplaint"
                class="mat-select-search"
              >
                <mat-option value="Todos">Todos</mat-option>
                <mat-option *ngFor="let type of typesComplaint" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div
          style="
            margin-top: 1.5rem;
            display: flex;
            width: 100%;
            justify-content: space-between;
          "
        >
          <div class="filters-input">
            <label class="label-input-search">Gênero</label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select
                formControlName="genderComplaint"
                class="mat-select-search"
              >
                <mat-option [value]="'Todos'">Todos</mat-option>
                <mat-option [value]="'WOMAN_TRANS'">Mulher trans</mat-option>
                <mat-option [value]="'WOMAN_CIS'">Mulher cis</mat-option>
                <mat-option [value]="'MAN_TRANS'">Homem trans</mat-option>
                <mat-option [value]="'MAN_CIS'">Homem cis</mat-option>
                <mat-option [value]="'NON_BINARY'">Não binário</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div
          style="
            margin-top: 1.5rem;
            display: flex;
            width: 100%;
            justify-content: space-between;
            margin-bottom: 15px;
          "
        >
          <div class="filters-input">
            <label class="label-input-search">Faixa etária</label>
            <mat-form-field
              id="select"
              style="
                width: 260px;
                background-color: #e5deff;
                border-radius: 8px;
              "
            >
              <mat-icon style="color: #5d53a7" matSuffix
                >keyboard_arrow_down</mat-icon
              >
              <mat-select formControlName="age" class="mat-select-search">
                <mat-option [value]="'Todos'">Todos</mat-option>
                <mat-option [value]="'<= 14'"><= 14</mat-option>
                <mat-option [value]="'15 - 18'">15 - 18</mat-option>
                <mat-option [value]="'19 - 29'">19 - 29</mat-option>
                <mat-option [value]="'30 - 39'">30 - 39</mat-option>
                <mat-option [value]="'40 - 49'">40 - 49</mat-option>
                <mat-option [value]="'50 - 59'">50 - 59</mat-option>
                <mat-option [value]="'>= 60'">>= 60</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <button
          (click)="getComplaintsRecurrent()"
          class="btn btn-outline-secundary custom-button mt-3"
          style="font-size: 1rem"
        >
          Filtrar
        </button>
        <button
          (click)="cleanFilters()"
          class="btn btn-outline-clear custom-button clear mt-3 text-decoration-underline"
          style="font-size: 1rem"
        >
          Limpar Filtros
        </button>
      </form>
    </div>
  </div>
</div>

<div
  [ngClass]="{ deactivate: loading === true }"
  class="background background-dash custom-background"
  id="home"
>
  <div class="container-fluid custom-container">
    <div class="custom-dashboard">
      <h2 class="custom-dashboard-heading">Dashboard</h2>
      <mat-spinner
        [diameter]="60"
        class="static-spinner"
        *ngIf="staticInfoLoading"
      ></mat-spinner>

      <div class="container-card-box" *ngIf="!staticInfoLoading">
        <div class="card-box">
          <div class="title-card-box">
            <img src="assets/icons/warning.svg" alt="" />
            <h4>CASOS REGISTRADOS</h4>
          </div>
          <div class="content-card-box">
            <h3 style="margin: 0px">
              {{
                dashboardCardsData
                  ? dashboardCardsData.total_complaints_in_interval
                  : "--"
              }}
            </h3>
          </div>

          <span>Nos últimos sete dias</span>
        </div>

        <div class="card-box">
          <div class="title-card-box">
            <img src="assets/icons/camera.svg" alt="" />
            <h4>IMAGENS DE SEGURANÇA</h4>
          </div>
          <div class="content-card-box">
            <h3 style="margin: 0px">
              {{
                dashboardCardsData ? dashboardCardsData.total_media_op : "--"
              }}
            </h3>
          </div>
          <span>Nos últimos sete dias</span>
        </div>

        <div class="card-box">
          <div class="title-card-box">
            <img src="assets/icons/phone.svg" alt="" />
            <h4>IMAGENS DOS RELATOS</h4>
          </div>
          <div class="content-card-box">
            <h3 style="margin: 0px">
              {{ dashboardCardsData ? dashboardCardsData.total_media : "--" }}
            </h3>
          </div>
          <span>Nos últimos sete dias</span>
        </div>
      </div>
    </div>
  </div>

  <div class="new-main-div">
    <div class="new-filter__container filter__container">
      <h4 class="new-h4">PERÍODO</h4>

      <div class="new-container-settings-filter container-settings-filter">
        <div class="new-input-group input-group">
          <div class="d-flex flex-row align-items-center">
            <div
              class="new-input-group-append input-group-append"
              style="cursor: pointer"
            >
              <div
                class="new-select__wrapper select__wrapper"
                (click)="openDatePicker()"
              >
                <div class="new-input input">{{ selectedLabel }}</div>
              </div>

              <mat-form-field class="new-mat-form-field">
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                  class="picker-color"
                  style="margin-right: 0.5rem"
                  id="picker-toggle"
                  (click)="openDatePicker()"
                >
                  <img
                    src="assets/icons/calendar.svg"
                    matDatepickerToggleIcon
                  />
                </mat-datepicker-toggle>
                <mat-datepicker-toggle
                  matSuffix
                  (click)="cleanDate()"
                  *ngIf="initialDate || endDate"
                >
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                <mat-date-range-input
                  [min]="minDate"
                  [max]="maxDate"
                  [rangePicker]="picker"
                  style="display: none"
                >
                  <input
                    matStartDate
                    [min]="minDate"
                    [max]="maxDate"
                    (dateChange)="onInitialDateChange($event)"
                  />
                  <input
                    matEndDate
                    (dateChange)="
                      onEndDateChange($event); getComplaintsRecurrent()
                    "
                  />
                </mat-date-range-input>
              </mat-form-field>
            </div>

            <button
              (click)="setShowFilters(true)"
              class="btn btn-outline-primary custom-button"
              style="margin: 0 1rem"
            >
              <img src="assets/icons/filters.svg" alt="" />
              FILTROS
            </button>

            <button
              (click)="getComplaintsRecurrent()"
              class="btn btn-outline-fortiary custom-button"
            >
              APLICAR
            </button>
          </div>

          <div style="display: flex; justify-content: flex-end">
            <div class="download-spinner">
              <mat-spinner
                [diameter]="30"
                style="margin-right: 3rem"
                *ngIf="loadingCsv"
              ></mat-spinner>
            </div>

            <button
              *ngIf="!loadingCsv"
              [matMenuTriggerFor]="menu"
              class="data-button d-flex btn btn-outline-success custom-button mt-auto"
              style="
                width: max-content;
                height: 100%;
                display: flex;
                padding: 0 2.25rem;
                justify-content: center;
                align-items: center;
              "
            >
              <mat-icon class="mr-md-2">file_download</mat-icon>
              <!-- ? add spinner -->

              <span class="btn-archive__text"> BAIXAR DADOS</span>

              <mat-menu #menu="matMenu" id="btn-download">
                <div class="download-menu">
                  <button (click)="getCsv()">CSV</button>
                  <button (click)="getCsv(true)">CSV com status</button>
                  <button class="active" (click)="getPdf()">PDF</button>
                </div>
              </mat-menu>
            </button>
          </div>
        </div>
      </div>

      <div
        *ngIf="selectedFilters.length > 0 || true"
        class="flex row items-center gap-2 flex-wrap"
        [style.padding]="selectedFilters.length > 0 ? '1rem' : '0'"
      >
        <div class="selected-filter" *ngFor="let filter of selectedFilters">
          {{ filter.name }}
          <mat-icon
            style="transform: scale(0.8); cursor: pointer"
            (click)="removeFilter(filter)"
            >close</mat-icon
          >
        </div>
      </div>
    </div>
  </div>
  <div class="container-last-ocurrances-map last-ocurrence">
    <div
      *ngIf="ocorrenciasFiltradas.length > 0"
      class="last-ocurrence-container"
    >
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
        "
      >
        <h3 class="ultimo-caso">Últimos casos</h3>
        <button class="btn-update" (click)="ngOnInit()">
          <img src="assets/icons/update.svg" class="me-1" /> Atualizar
        </button>
      </div>
      <div class="last-ocurrence-list">
        <div
          *ngFor="let ocurrence of ocorrenciasFiltradas"
          class="ocurrence"
          [routerLink]="'/home/ocurrences-details/' + ocurrence._id"
          id="ocurrence._id"
        >
          <div
            class="ocurrence-information"
            style="display: flex; flex-direction: column"
          >
            <div class="ocurrence-title" style="display: flex; gap: 10px">
              <p class="text-ocurrence">{{ ocurrence?._id }}</p>
              <img
                src="assets/icons/bus.svg"
                *ngIf="ocurrence.bus_number"
                alt=""
              />
            </div>

            <div class="time-ocurrence" style="display: flex; margin-top: 3px">
              <img src="assets/icons/clock.svg" alt="" />
              <p class="text-ocurrence-time">
                {{ ocurrence.time_since_creation }}
              </p>
            </div>

            <div
              class="type-ocurrence"
              style="display: flex; gap: 10px; margin-top: 10px"
            >
              <span
                *ngFor="let type of ocurrence.type.slice(0, 2)"
                class="span-ocurrence-type"
                >{{ translateType(type) }}</span
              >

              <span
                *ngIf="ocurrence.type.length > 2"
                class="span-ocurrence-type"
                >...</span
              >
            </div>
          </div>
          <div class="more-details">
            <img src="assets/icons/eye.svg" alt="mais detalhes" />
          </div>
        </div>
      </div>

      <button [routerLink]="'/home/ocurrences'" class="see-all-ocurrences">
        Ver todas as ocorrências

        <img src="assets/icons/go-icon.svg" alt="" />
      </button>
    </div>

    <div
      *ngIf="ocorrenciasFiltradas.length == 0 || !ocorrenciasFiltradas"
      class="last-ocurrence-container no-data"
    >
      Não foi possível encontrar dados relativos à sua busca.
    </div>
    <div id="map" style="flex: 70%; border-radius: 16px">
      <agm-map [latitude]="center.lat" [longitude]="center.lng" [zoom]="15">
        <agm-marker
          [iconUrl]="'./../../assets/images/pin.png'"
          [latitude]="center.lat"
          [longitude]="center.lng"
        ></agm-marker>
      </agm-map>
    </div>
  </div>

  <div
    class="container-analise-casos"
    id="container-analise-casos"
    style="width: 100%; max-width: 1300px; margin: 0 auto; margin-top: 30px"
  >
    <div
      (click)="openDialogShowGraphs()"
      class="titulo"
      style="display: flex; align-items: center; gap: 20px"
    >
      <h2
        style="
          margin: 0;
          color: var(--material-theme-ref-primary-primary-10, #180064);
          font-family: Roboto;
          font-size: 36px;
          font-style: normal;
          font-weight: 500;
          line-height: 44px;
        "
      >
        Análise de casos
      </h2>
      <div class="settings-button">
        <img src="assets/icons/settings.svg" alt="" />
      </div>
    </div>

    <div
      class="map-data-container"
      style="display: flex; gap: 20px; margin-top: 20px"
    >
      <div
        class="map"
        style="flex: 0.8; height: 370px; background: #fff; border-radius: 16px"
      >
        <app-line-chart
          [monthData]="res ? res.year_month_count : []"
          *ngIf="(loading$ | async) === false"
        ></app-line-chart>
      </div>
      <div
        class="data"
        style="display: flex; flex: 0.2; height: 370px; gap: 20px"
      >
        <div
          class="container-card"
          style="display: flex; flex-direction: column; flex: 1; gap: 20px"
        >
          <div
            class="card-data"
            style="
              width: calc(100%);
              height: 100%;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 16px;
            "
          >
            <div
              class="information-data"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <p
                class="numero-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-primary-primary-10, #180064);
                  font-family: Roboto;
                  font-size: 45px;
                  font-style: normal;
                  font-weight: 450;
                  line-height: 52px;
                "
              >
                {{ checkinPercentage ? checkinPercentage : 0 }}
              </p>
              <p
                class="texto-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-neutral-neutral-20, #323033);
                  font-family: Roboto;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  width: calc(100% - 30px);
                  text-align: center;
                  line-height: 24px;
                "
              >
                Das ocorrências com check-in em centros de acolhimento
              </p>
            </div>
          </div>
          <div
            class="card-data"
            style="
              width: calc(100%);
              height: 100%;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 16px;
            "
          >
            <div
              class="information-data"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <p
                class="numero-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-primary-primary-10, #180064);
                  font-family: Roboto;
                  font-size: 45px;
                  font-style: normal;
                  font-weight: 450;
                  line-height: 52px;
                "
              >
                {{ casosMomentoOcorridos ? casosMomentoOcorridos : 0 }}
              </p>
              <p
                class="texto-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-neutral-neutral-20, #323033);
                  font-family: Roboto;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  width: calc(100% - 30px);
                  text-align: center;
                  line-height: 24px;
                "
              >
                Casos registrados no momento do ocorrido
              </p>
            </div>
          </div>
          <div
            class="card-data"
            style="
              width: calc(100%);
              height: 100%;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 16px;
            "
          >
            <div
              class="information-data"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <p
                class="numero-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-primary-primary-10, #180064);
                  font-family: Roboto;
                  font-size: 45px;
                  font-style: normal;
                  font-weight: 450;
                  line-height: 52px;
                "
              >
                {{ casosAposOcorridos ? casosAposOcorridos : 0 }}
              </p>
              <p
                class="texto-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-neutral-neutral-20, #323033);
                  font-family: Roboto;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  width: calc(100% - 30px);
                  text-align: center;
                  line-height: 24px;
                "
              >
                Casos registrados após o ocorrido
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="container-graficos-nav"
    style="
      cursor: pointer;
      margin: 60px auto 30px auto;
      width: 100%;
      max-width: 1300px;
      height: 60px;
      border-bottom: 1px solid #e5deff;
      display: flex;
      align-items: center;
    "
  >
    <ul style="display: flex; width: 100%; gap: 20px; min-width: 400px">
      <li
        style="width: auto; min-height: 25px; border: none"
        (click)="activeNavGraph($event)"
        *ngFor="let titleGraphs of elementsNavGraphs"
        id="{{ retirarEspacos(titleGraphs) }}"
      >
        {{ titleGraphs }}
      </li>
    </ul>
  </div>

  <div
    class="container-graficos"
    style="width: 100%; max-width: 1300px; margin: 0 auto"
  >
    <div class="Dadossobreimportunação none">
      <app-importunation-data
        [dataAgressions]="res"
        elId="importunation-data"
        style="width: 100%; height: auto"
      ></app-importunation-data>
    </div>
    <div
      class="Etnografia none"
      style="width: 100%; max-width: 1300px; margin: 0 auto"
    >
      <app-etnografia-data
        [dataAgressions]="res"
        elId="etnografia-data"
        style="width: 100%; height: auto"
      ></app-etnografia-data>
    </div>
    <div
      class="Frequência none"
      style="width: 100%; max-width: 1300px; margin: 0 auto"
    >
      <app-horario-data
        [dataAgressions]="res"
        elId="horario-data"
        style="width: 100%; height: auto"
      ></app-horario-data>
    </div>
  </div>

  <div class="local-ranking">
    <div class="local-ranking-title">
      <div>
        <strong>Ranking de casos por local</strong>
      </div>
    </div>

    <div class="d-flex flex-column w-100">
      <div
        class="d-flex flex-row flex-wrap align-items-center justify-content-center w-100"
      >
        <div class="ranking-card" *ngIf="rankings?.bus?.length > 0">
          <div class="ranking-card-title">
            <div class="ranking-card-title-icon">
              <img src="assets/icons/bus-ranking.svg" alt="" />
            </div>
            <strong>Casos por Linha de Ônibus</strong>
          </div>

          <div class="ranking-card-subheader">
            <span>LOCAL</span>
            <span>CASOS</span>
          </div>

          <div class="ranking-list">
            <div class="ranking-row" *ngFor="let row of rankings?.bus">
              <div class="ranking-row-name">
                <div class="ranking-row-name-icon">
                  <img src="assets/icons/bus.svg" alt="" />
                </div>
                {{ row.name }}
              </div>

              <div class="ranking-row-cases">{{ row.value }}</div>
            </div>
          </div>
        </div>
        <div class="ranking-card" *ngIf="rankings?.subway?.length > 0">
          <div class="ranking-card-title">
            <div class="ranking-card-title-icon">
              <img src="assets/icons/metro-ranking.svg" alt="" />
            </div>
            <strong>Casos por Linha de Metrô</strong>
          </div>

          <div class="ranking-card-subheader">
            <span>LOCAL</span>
            <span>CASOS</span>
          </div>

          <div class="ranking-list">
            <div class="ranking-row" *ngFor="let row of rankings?.subway">
              <div class="ranking-row-name">
                <div class="ranking-row-name-icon">
                  <img src="assets/icons/metro-ranking.svg" alt="" />
                </div>
                {{ row.name }}
              </div>

              <div class="ranking-row-cases">{{ row.value }}</div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="d-flex flex-row flex-wrap align-items-center justify-content-center mt-4 w-100"
      >
        <div class="ranking-card" *ngIf="rankings?.bus_terminal?.length > 0">
          <div class="ranking-card-title">
            <div class="ranking-card-title-icon">
              <img src="assets/icons/terminal-ranking.svg" alt="" />
            </div>
            <strong>Casos por Terminal</strong>
          </div>

          <div class="ranking-card-subheader">
            <span>LOCAL</span>
            <span>CASOS</span>
          </div>

          <div class="ranking-list">
            <div class="ranking-row" *ngFor="let row of rankings?.bus_terminal">
              <div class="ranking-row-name">
                <div class="ranking-row-name-icon">
                  <img src="assets/icons/terminal-ranking.svg" alt="" />
                </div>
                {{ row.name }}
              </div>

              <div class="ranking-row-cases">{{ row.value }}</div>
            </div>
          </div>
        </div>
        <div class="ranking-card" *ngIf="rankings?.bus_stop?.length > 0">
          <div class="ranking-card-title">
            <div class="ranking-card-title-icon">
              <img src="assets/icons/sublocality-ranking.svg" alt="" />
            </div>
            <strong>Bairros com paradas críticas</strong>
          </div>

          <div class="ranking-card-subheader">
            <span>LOCAL</span>
            <span>CASOS</span>
          </div>

          <div class="ranking-list">
            <div class="ranking-row" *ngFor="let row of rankings?.bus_stop">
              <div class="ranking-row-name">
                <div class="ranking-row-name-icon">
                  <img src="assets/icons/sublocality-ranking.svg" alt="" />
                </div>
                {{ row.name }}
              </div>

              <div class="ranking-row-cases">{{ row.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  style="position: absolute; left: -9999px; width: 1600px"
  class="d-flex flex-column relatory"
  id="relatory-page-1"
>
  <div class="relatory-header">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <h1>Relatório de denúncias</h1>

      <img src="assets/icons/logo.svg" alt="" />
    </div>
  </div>

  <div class="relatory-body">
    <div class="d-flex flex-row" style="gap: 3%">
      <div class="relatory-container" style="width: 55%">
        <div class="d-flex flex-row align-items-center">
          <div class="relatory-icon">
            <img src="assets/icons/relatory-calendar.svg" alt="" />
          </div>
          <strong class="sub-title">Intervalo de Ocorrências</strong>
        </div>

        <div class="d-flex flex-row align-items-center mt-4">
          <p>
            Data inicial
            <span>{{
              res && res.start_date ? formatDate(res.start_date) : "01/01/2022"
            }}</span>
          </p>
          <p>
            Data final
            <span>{{
              res && res.end_date ? formatDate(res.end_date) : formatDate(today)
            }}</span>
          </p>
        </div>
      </div>

      <div class="relatory-container" style="width: 42%">
        <div class="d-flex flex-row align-items-center">
          <div class="relatory-icon">
            <img src="assets/icons/danger.svg" alt="" />
          </div>
          <strong class="sub-title">Total de casos do período</strong>
        </div>

        <div
          class="d-flex flex-row justify-content-center align-items-center mt-4"
          style="color: #180064; width: 80%"
        >
          <p>
            <strong>{{
              res && res?.total_filtered_complaints
                ? res.total_filtered_complaints
                : 0
            }}</strong>
            casos registrados
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex flex-row" style="margin-top: 3rem">
      <div class="relatory-container" style="width: 100%">
        <div class="d-flex flex-row align-items-center">
          <div class="relatory-icon">
            <img src="assets/icons/relatory-calendar.svg" alt="" />
          </div>
          <strong class="sub-title"
            >Quantidade de denúncias por situação</strong
          >
        </div>

        <div class="situation-reports">
          <div class="d-flex flex-row align-items-center">
            <div class="situation-reports-icon">
              <img src="assets/icons/people.svg" alt="" />
            </div>
            <div class="d-flex flex-column">
              <span class="mb-2">Vítima</span>
              <strong
                >{{
                  res && res.category_counts?.complainer_type
                    ? res.category_counts.complainer_type["Vítima"]
                    : 0
                }}
                denúncias</strong
              >
            </div>
          </div>

          <div
            class="d-flex flex-row align-items-center"
            style="margin-left: 2.5rem"
          >
            <div class="situation-reports-icon">
              <img src="assets/icons/person.svg" alt="" />
            </div>
            <div class="d-flex flex-column">
              <span class="mb-2">Testemunha</span>
              <strong
                >{{
                  res && res.category_counts?.complainer_type
                    ? res.category_counts.complainer_type["Testemunha"]
                    : 0
                }}
                denúncias</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="container-analise-casos"
    id="container-analise-casos"
    style="width: 100%; max-width: 1300px; margin: 0 auto; margin-top: 4rem"
  >
    <div
      (click)="openDialogShowGraphs()"
      class="titulo"
      style="display: flex; align-items: center; gap: 20px"
    >
      <h2
        style="
          margin: 0;
          color: var(--material-theme-ref-primary-primary-10, #180064);
          font-family: Roboto;
          font-size: 36px;
          font-style: normal;
          font-weight: 500;
          line-height: 44px;
        "
      >
        Análise de casos
      </h2>
      <div class="settings-button">
        <img src="assets/icons/settings.svg" alt="" />
      </div>
    </div>

    <div
      class="map-data-container"
      style="display: flex; gap: 20px; margin-top: 20px"
    >
      <div
        class="map"
        style="flex: 0.8; height: 370px; background: #fff; border-radius: 16px"
      >
        <app-line-chart
          [monthData]="res ? res.year_month_count : []"
          *ngIf="(loading$ | async) === false"
        ></app-line-chart>
      </div>
      <div
        class="data"
        style="display: flex; flex: 0.2; height: 370px; gap: 20px"
      >
        <div
          class="container-card"
          style="display: flex; flex-direction: column; flex: 1; gap: 20px"
        >
          <div
            class="card-data"
            style="
              width: calc(100%);
              height: 100%;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 16px;
            "
          >
            <div
              class="information-data"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <p
                class="numero-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-primary-primary-10, #180064);
                  font-family: Roboto;
                  font-size: 45px;
                  font-style: normal;
                  font-weight: 450;
                  line-height: 52px;
                "
              >
                {{ checkinPercentage ? checkinPercentage : 0 }}
              </p>
              <p
                class="texto-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-neutral-neutral-20, #323033);
                  font-family: Roboto;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  width: calc(100% - 30px);
                  text-align: center;
                  line-height: 24px;
                "
              >
                Das ocorrências com check-in em centros de acolhimento
              </p>
            </div>
          </div>
          <div
            class="card-data"
            style="
              width: calc(100%);
              height: 100%;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 16px;
            "
          >
            <div
              class="information-data"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <p
                class="numero-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-primary-primary-10, #180064);
                  font-family: Roboto;
                  font-size: 45px;
                  font-style: normal;
                  font-weight: 450;
                  line-height: 52px;
                "
              >
                {{ casosMomentoOcorridos ? casosMomentoOcorridos : 0 }}
              </p>
              <p
                class="texto-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-neutral-neutral-20, #323033);
                  font-family: Roboto;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  width: calc(100% - 30px);
                  text-align: center;
                  line-height: 24px;
                "
              >
                Casos registrados no momento do ocorrido
              </p>
            </div>
          </div>
          <div
            class="card-data"
            style="
              width: calc(100%);
              height: 100%;
              background: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 16px;
            "
          >
            <div
              class="information-data"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <p
                class="numero-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-primary-primary-10, #180064);
                  font-family: Roboto;
                  font-size: 45px;
                  font-style: normal;
                  font-weight: 450;
                  line-height: 52px;
                "
              >
                {{ casosAposOcorridos ? casosAposOcorridos : 0 }}
              </p>
              <p
                class="texto-data"
                style="
                  margin: 0;
                  color: var(--material-theme-ref-neutral-neutral-20, #323033);
                  font-family: Roboto;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  width: calc(100% - 30px);
                  text-align: center;
                  line-height: 24px;
                "
              >
                Casos registrados após o ocorrido
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="container-graficos"
    style="
      width: 100%;
      max-width: 1300px;
      margin: 0 auto;
      margin-bottom: 2rem;
      display: flex;
      flex-direction: column;
    "
  >
    <app-importunation-data
      [dataAgressions]="res"
      elId="importunation-data-relatory"
      style="width: 100%; height: auto"
    ></app-importunation-data>

    <app-etnografia-data
      [dataAgressions]="res"
      elId="etnografia-data-relatory"
      style="width: 100%; height: auto"
    ></app-etnografia-data>

    <app-horario-data
      [dataAgressions]="res"
      elId="horario-data-relatory"
      style="width: 100%; height: auto; margin-top: 28rem"
    ></app-horario-data>
  </div>
</div>
